import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (authError) {
      setError("E-mail ou senha inválidos. Verifique suas credenciais.");
    } else {
      navigate("/admin/dashboard");
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-[#1B1F5E] rounded flex items-center justify-center">
              <span className="font-rajdhani font-black text-white text-xl leading-none">N</span>
            </div>
            <div className="flex flex-col leading-none text-left">
              <span className="font-rajdhani font-black text-[#1a1a1a] text-xl tracking-tight">NEW TECH</span>
              <span className="text-[#3FA7D6] text-[10px] font-semibold tracking-widest uppercase">Solution</span>
            </div>
          </div>
          <p className="text-gray-500 text-sm mt-3">Painel Administrativo</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-xl p-8 border border-gray-200">
          <h1 className="text-xl font-bold text-[#1a1a1a] mb-1">Entrar no painel</h1>
          <p className="text-gray-500 text-sm mb-6">Use suas credenciais de administrador</p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-lg mb-5 flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-error-warning-line"></i>
              </div>
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#333] mb-1.5">E-mail</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@newtechsolution.com.br"
                  required
                  className="w-full pl-9 pr-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#1B1F5E] transition-colors"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-[#333] mb-1.5">Senha</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
                  <i className="ri-lock-line text-sm"></i>
                </div>
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  className="w-full pl-9 pr-10 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#1B1F5E] transition-colors"
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className={`${showPass ? "ri-eye-off-line" : "ri-eye-line"} text-sm`}></i>
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1B1F5E] hover:bg-[#2F4F8F] disabled:opacity-60 text-white font-bold py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 mt-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-loader-4-line animate-spin text-sm"></i>
                  </div>
                  Entrando...
                </>
              ) : (
                "Entrar"
              )}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          &copy; {new Date().getFullYear()} New Tech Solution. Todos os direitos reservados.
        </p>
      </div>
    </div>
  );
}
